<div class="filter-tray">
    <div class="tray-items" [formGroup]="byBranchForm">
        <div formArrayName="branches">
            <div class="tray-row" *ngFor="let branchCtrl of branches.controls; let i = index">
                <single-choice
                    [formControl]="branchCtrl"
                    (click)="setEditingIndex(i)"
                    [completedUrl]="completionUrl"
                    [topic]="'branches'"
                    [editMode]="true"
                    [ticketId]="fakeId"
                    (choiceEvent)="relaySingleChoice($event)"
                    [labelOnDemand]="branchLabelerByService"
                    [choiceObserver]="branchObserver">
                </single-choice>
                <button type="button" class="row-remove" (click)="removeField(i)" [disabled]="branches.length <= 1">
                    <i class="material-icons-outlined">close</i>
                </button>
            </div>
        </div>
    </div>
    <div class="tray-footer">
        <button type="button" class="add-btn" (click)="addBranchField()">
            <i class="material-icons-outlined">add</i>
        </button>
        <not [filter]="byBranchFilter" (filterChanged)="onFilterChanged($event)"></not>
        <button class="apply-btn" type="button" (click)="apply()">{{ 'filter.apply' | translate }}</button>
    </div>
</div>
